import { AccountCloseoutResponse } from '../../services/closeout/types';

import { CloseoutState } from './types';

export const INITIAL_STATE: CloseoutState = {
  error: undefined,
  errorsLog: [],
  statusByCall: {},
  accountStatusData: {
    dailyLoss: 0,
    maxLoss: 0,
    totalUnrealizedPnl: 0,
    dailyRealizedPnl: 0,
  } as AccountCloseoutResponse,

  // SSE Connection state
  sseConnected: false,
  sseError: null,

  // SSE Event state
  profitTargetReached: false,
  isTradingPlanCompleted: false,
  isDailyAutoClose: false,
};

